<template>
  <div class="page">
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <a href="#">{{ $t("sales") }}</a>
          </li>
          <li>-</li>
          <li>
            <a href="#">{{ $t("offer") }} {{ $t("price") }}</a>
          </li>
          <li>-</li>
          <li>
            <a class="active" href="#"
              >{{ $t("add") }} {{ $t("offer") }} {{ $t("price") }}</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="head-option">
      <ul>
        <!-- <li>
              <a href="#" class="btn-download">
                <span class="text">Download PDF</span>
              </a>
            </li> -->
        <li>
          <router-link to="/AdminDashboard/OfferPrice" class="btn-download">
            <span class="text">
              <i class="bi bi-arrow-left-square-fill"></i>
              {{ $t("back") }}</span
            >
          </router-link>
        </li>
      </ul>
    </div>
    <div class="main">
      <div class="head">
        <h3>{{ $t("add") }} {{ $t("offer") }} {{ $t("price") }}</h3>
      </div>
      <div class="body">
        <div class="part1">
          <div class="part11">
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
                >{{ $t("number") }}
                <span class="error-feedback" v-if="v$.number.$error">{{
                  "*"
                }}</span></label
              >
              <div class="col-sm-7">
                <div class="col-sm-7">QTE-{{ number }}</div>
              </div>
            </div>
            <!--  -->
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
                >{{ $t("date") }}
                <span class="error-feedback" v-if="v$.date.$error">{{
                  "*"
                }}</span></label
              >
              <div class="col-sm-7">
                <input
                  type="date"
                  class="form-control form-control-sm"
                  id="inputEmail3"
                  v-model="date"
                />
              </div>
            </div>
            <!--  -->
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
                >{{ $t("description") }}
                <span class="error-feedback" v-if="v$.description.$error">{{
                  "*"
                }}</span></label
              >
              <div class="col-sm-7">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="inputEmail3"
                  v-model="description"
                />
              </div>
            </div>
            <!--  -->
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
                >{{ $t("customer") }}
                <span class="error-feedback" v-if="v$.customername.$error">{{
                  "*"
                }}</span>
              </label>
              <div class="col-sm-7">
                <v-select :options="customers" label="name" v-model="cdata">
                  <template #option="option">
                    <span>{{ option.name }}</span>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="part12">
            <h4>{{ $t("data") }} {{ $t("customer") }}</h4>

            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("name") }}
              </label>
              <div class="col-sm-7">
                {{ customerdata.name }}
              </div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("mobile") }}
              </label>
              <div class="col-sm-7">
                {{ customerdata.mobile }}
              </div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("email") }}
              </label>
              <div class="col-sm-7">
                {{ customerdata.email }}
              </div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("tax") }}
              </label>
              <div class="col-sm-7">
                {{ customerdata.taxnumber }}
              </div>
            </div>
          </div>
        </div>
        <div class="part2">
          <div class="mb-2 row">
            <label for="inputEmail3" class="col-sm-2 col-form-label-sm"
              >{{ $t("barcode") }}
            </label>
            <div class="col-sm-1">
              <input
                type="text"
                class="form-control form-control-sm"
                id="inputEmail3"
                @change="getbarcode"
                v-model="barcode"
              />
            </div>
          </div>
          <div class="mb-2 row">
            <label for="inputEmail3" class="col-sm-2 col-form-label-sm"
              >{{ $t("product") }}
            </label>
            <div class="col-sm-3">
              <v-select :options="products" label="namear" v-model="product">
                <template #option="option">
                  <span>{{ option.barcode }} - {{ option.namear }}</span>
                </template>
              </v-select>
            </div>
            <!-- <div class="col-sm-3">
              <button
                class="btn btn-primary"
                @click="Addproduct"
                style="padding: 0.25%"
              >
                {{ $t("add") }} <i class="bi bi-plus"></i>
              </button>
            </div> -->
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th style="width: 12%">{{ $t("product") }}</th>
                <th>{{ $t("description") }}</th>
                <th style="width: 10%">{{ $t("quantity") }}</th>
                <th style="width: 10%">{{ $t("unit type") }}</th>
                <th>{{ $t("price") }}</th>
                <th>{{ $t("discount") }}</th>
                <th>{{ $t("total") }} {{ $t("befor") }} {{ $t("tax") }}</th>
                <th>{{ $t("tax") }}</th>
                <th>{{ $t("amount") }} {{ $t("tax") }}</th>
                <th>{{ $t("total") }}</th>
                <th>{{ $t("cancel") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, id) in data" :key="value">
                <td>{{ id + 1 }}</td>
                <td style="width: 20%">
                  <span
                    >{{ value.product.barcode }} -
                    {{ value.product.namear }}</span
                  >
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="value.description"
                  />
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="value.quantity"
                    @change="
                      value.proid = value.product.id;
                      value.pronamear = value.product.namear;
                      value.pronameen = value.product.nameen;
                      value.salep = value.product.salep;
                      value.salec = value.product.salec;
                      value.snamear = value.product.snamear;
                      value.snameen = value.product.snameen;
                      value.buyp = value.product.buyp;
                      value.buyc = value.product.buyc;
                      value.bnamear = value.product.bnamear;
                      value.bnameen = value.product.bnameen;
                      value.discount = value.product.discount;
                      value.unittype = value.product.unittype;
                      value.tax = value.product.tax;
                      value.sn = value.product.sn;
                      value.barcode = value.product.barcode;
                      value.tbt =
                        value.salep * value.quantity -
                        (value.salep * value.quantity * value.discount) / 100;
                      value.taxamount = (value.tbt * value.tax) / 100;
                      value.total = value.tbt + (value.tbt * value.tax) / 100;
                      value.costbt =
                        value.buyp * value.quantity -
                        (value.buyp * value.quantity * value.discount) / 100;
                      value.cost =
                        value.costbt + (value.costbt * value.tax) / 100;
                      this.calc();
                    "
                  />
                </td>
                <td>{{ value.unittype }}</td>
                <td>
                  <input
                    type="number"
                    v-model="value.salep"
                    @change="
                      value.tbt =
                        value.salep * value.quantity -
                        (value.salep * value.quantity * value.discount) / 100;
                      value.taxamount = (value.tbt * value.tax) / 100;
                      value.total = value.tbt + (value.tbt * value.tax) / 100;
                      value.costbt =
                        value.buyp * value.quantity -
                        (value.buyp * value.quantity * value.discount) / 100;
                      value.cost =
                        value.costbt + (value.costbt * value.tax) / 100;
                      this.calc();
                    "
                  />
                </td>
                <td>{{ value.discount }} %</td>
                <td>{{ value.tbt }}</td>
                <td style="display: flex">
                  <input
                    type="number"
                    v-model="value.tax"
                    style="width: 100px"
                    @change="
                      value.tbt =
                        value.salep * value.quantity -
                        (value.salep * value.quantity * value.discount) / 100;
                      value.taxamount = (value.tbt * value.tax) / 100;
                      value.total = value.tbt + (value.tbt * value.tax) / 100;
                      value.costbt =
                        value.buyp * value.quantity -
                        (value.buyp * value.quantity * value.discount) / 100;
                      value.cost =
                        value.costbt + (value.costbt * value.tax) / 100;
                      this.calc();
                    "
                  />
                  %
                </td>
                <td>{{ value.taxamount }}</td>
                <td>{{ value.total }}</td>
                <td>
                  <a href="#" @click.prevent="del(id)"
                    ><i class="bi bi-x-circle-fill"></i
                  ></a>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="6"></td>
                <td>{{ $t("total") }}</td>
                <td>{{ tbt }}</td>
                <td></td>
                <td>{{ taxamount }}</td>
                <td>{{ total }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="mb-2 row">
          <label class="col-sm-1 col-form-label-sm">{{ $t("branch") }} </label>
          <div class="col-sm-2">
            <select
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              v-model="branchno"
            >
              <option v-for="val in branches" :key="val" :value="val.id">
                {{ val.namear }}
              </option>
            </select>
          </div>
        </div>
        <div class="mb-2 row">
          <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
            >{{ $t("add") }} {{ $t("to") }}
          </label>

          <div class="col-sm-1">
            <input
              class="form-check-input"
              type="radio"
              value="project"
              v-model="addto"
            />
            &nbsp;
            <label class="form-check-label" for="gridRadios2">
              {{ $t("project") }}
            </label>
          </div>
          <div class="col-sm-1">
            <input
              class="form-check-input"
              type="radio"
              v-model="addto"
              value="task"
            />
            &nbsp;
            <label class="form-check-label" for="gridRadios2">
              {{ $t("task") }}
            </label>
          </div>
          <div class="mb-2 row" v-if="addto == 'project'">
            <label class="col-sm-1 col-form-label-sm"
              >{{ $t("project") }}
            </label>
            <div class="col-sm-2">
              <select
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                v-model="projectno"
              >
                <option v-for="val in allprojects" :key="val" :value="val.id">
                  {{ val.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-2 row" v-if="addto == 'task'">
            <label class="col-sm-1 col-form-label-sm">{{ $t("task") }} </label>
            <div class="col-sm-2">
              <select
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                v-model="taskno"
                @change="task"
              >
                <option v-for="val in alltasks" :key="val.id" :value="val.id">
                  {{ val.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="mb-2 row">
          <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
            >{{ $t("notes") }}
          </label>
          <div class="col-sm-5">
            <!-- <textarea
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              v-model="notes"
            ></textarea> -->
            <button @click="notes.push({})">+</button>
            <ul>
              <li v-for="value in notes" :key="value"><input type="text" v-model="value.note" style="width: 100%;"></li>
            </ul>
          </div>
        </div>
        <div class="buttom">
          <button class="buttonconfirm" type="submit" @click="submit">
            {{ $t("save") }}
          </button>
          &nbsp;&nbsp;&nbsp;
          <button class="buttoncancel" type="submit" @click="back">
            {{ $t("cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import useValidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import vSelect from "vue-select";
export default {
  title: `Create Offer Price`,
  components: {
    vSelect,
  },
  props: ["css"],
  async mounted() {
    const result3 = await axios.get("/data/allcustomer");
    if (result3.status == 200) {
      this.customers = result3.data.data;
      this.allcustomer = result3.data.data;
    }
    const result2 = await axios.get("/data/allproducts");
    if (result2.status == 200) {
      this.products = result2.data.data;
      this.allproducts = result2.data.data;
    }
    const result4 = await axios.get("/data/allprojects");
    const result5 = await axios.get("/data/alltasks");
    const result1 = await axios.get("/data/allbranches");
    const result6 = await axios.get("/data/OfferPriceID");
    if (result4.status == 200) {
      this.allprojects = result4.data.data;
      this.alltasks = result5.data.data;
      this.branches = result1.data.data;
      this.number = Number(result6.data.data[0].count) + Number(1);
    }
  },
  data() {
    return {
      v$: useValidate(),
      data: [],
      number: "",
      date: "",
      description: "",
      customers: [],
      allcustomer: [],
      products: [],
      product: "",
      allproducts: [],
      selection: false,
      customerid: "",
      customername: "",
      customerdata: "",
      taxamount: 0,
      tbt: 0,
      total: 0,
      addto: "",
      allprojects: [],
      alltasks: [],
      branches: [],
      taskno: "",
      projectno: "",
      branchno: "",
      filter: "",
      filter2: "",
      arrvalidate: false,
      cdata: "",
      notes:[{}]
    };
  },
  validations() {
    return {
      date: { required },
      description: { required },
      number: { required },
      customername: { required },
    };
  },
  methods: {
    back() {
      this.$root.$router.push({
        path: "/AdminDashboard/OfferPrice",
      });
    },
    async del(id) {
      this.data.splice(id, 1);
    },
    calc() {
      this.tbt = this.data.reduce((acc, array) => acc + Number(array.tbt), 0);
      this.taxamount = this.data.reduce(
        (acc, array) => acc + Number(array.taxamount),
        0
      );
      this.total = this.data.reduce(
        (acc, array) => acc + Number(array.total),
        0
      );
    },
    task() {
      const project = this.alltasks.filter((x) => x.id == this.taskno)[0]
        .projectid;
      this.projectno = project;
    },
    async submit() {
      for (let i = 0; i < this.data.length; i++) {
        const element = this.data[i];
        if (element.sn != null && element.quantity != null) {
          this.arrvalidate = true;
        } else {
          this.arrvalidate = false;
        }
      }
      this.v$.$validate();
      if (!this.v$.$error && this.arrvalidate == true) {
        console.log(this.customerdata);
        const result = await axios.post("/data/CreateOfferPrice", {
          username: store.state.randp.username,
          due: this.date,
          description: this.description,
          cid: this.customerdata.cid,
          cname: this.customerdata.name,
          cmobile: this.customerdata.mobile,
          cmail: this.customerdata.email,
          ctax: this.customerdata.taxnumber,
          details: JSON.stringify(this.data),
          tbt: this.tbt,
          tax: this.taxamount,
          tat: this.total,
          branch: this.branchno,
          project: this.projectno,
          task: this.taskno,
          notes: JSON.stringify(this.notes),
        });
        if (result.status == 200) {
          this.redirectTo({ val: "OfferPrice" });
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Data Entry successfully",
          });
          // this.redirectTo({ val: "Home" });
        } else if (result.status == 401) {
          alert("Account Already Created Before");
        }
      } else {
        alert("برجاء مراجعة البيانات");
      }
    },
    ...mapActions(["redirectTo"]),
  },
  watch: {
    async cdata() {
      const result3 = await axios.get(`/data/delcustomer/${this.cdata.cid}`);
      if (result3.status == 200) {
        this.customerdata = result3.data.data[0];
        this.customername = this.customerdata.name;
        this.customerid = this.customerdata.id;
      }
    },
    addto() {
      this.projectno = null;
      this.taskno = null;
    },
    filter() {
      this.customers = this.allcustomer.filter((x) =>
        x.name.includes(this.filter.toLowerCase())
      );
    },
    filter2() {
      this.products = this.allproducts.filter((x) =>
        x.namear.includes(this.filter2.toLowerCase())
      );
    },
    product() {
      const data2 = this.data.filter((x) => x.pronamear == this.product.namear);
      if (data2.length == 0) {
        this.data.push({
          proid: this.product.id,
          pronamear: this.product.namear,
          pronameen: this.product.nameen,
          salep: this.product.salep,
          salec: this.product.salec,
          snamear: this.product.snamear,
          snameen: this.product.snameen,
          buyp: this.product.buyp,
          buyc: this.product.buyc,
          bnamear: this.product.bnamear,
          bnameen: this.product.bnameen,
          discount: this.product.discount,
          unittype: this.product.unittype,
          tax: this.product.tax,
          sn: this.product.sn,
          barcode: this.product.barcode,
          product: this.product,
          quantity: 1,
          tbt:
            this.product.salep -
            (this.product.salep * 1 * this.product.discount) / 100,
          taxamount:
            ((this.product.salep -
              (this.product.salep * 1 * this.product.discount) / 100) *
              this.product.tax) /
            100,
          total:
            this.product.salep -
            (this.product.salep * 1 * this.product.discount) / 100 +
            ((this.product.salep -
              (this.product.salep * 1 * this.product.discount) / 100) *
              this.product.tax) /
              100,
          costbt: this.product.buyp,
          cost: this.product.buyp,
        });
        this.calc();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  direction: v-bind("css.EN");
  padding: 1%;
}
a {
  text-decoration: none;
}
.head-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-gap: 16px;
  flex-wrap: wrap;
}
.head-title .left h1 {
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #342e37;
}
.head-title .left .breadcrumb {
  display: flex;
  align-items: center;
  grid-gap: 16px;
}
.head-title .left .breadcrumb li {
  color: #342e37;
}
.head-title .left .breadcrumb li a {
  color: #aaaaaa;
  pointer-events: none;
}
.head-title .left .breadcrumb li a.active {
  color: v-bind("css.color");
  pointer-events: unset;
}

.head-option {
  direction: v-bind("css.AR");
  width: 100%;
  // border: #342e37 1px solid;
  padding: 0.5%;
}
.head-option ul li {
  display: inline;
  padding: 0.5%;
}
.head-option .btn-download {
  width: 20%;
  padding: 0.5%;
  border-radius: 5px;
  background: v-bind("css.color");
  color: #f9f9f9;
}
.main .head {
  border-top: v-bind("css.color") 5px solid;
  background: v-bind("css.color");
  color: #f9f9f9;
  border-radius: 3px 3px 0px 0px;
  padding: 0.25%;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.main .body {
  background: v-bind("css.light");
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 1%;
  //   display: flex;
}
.main .body .part1 {
  background: v-bind("css.light");
  //   box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 1%;
  display: flex;
  width: 100%;
}
.main .body .part11 {
  width: 50%;
}
.main .body .part12 {
  width: 40%;
  //   border: solid rgba(0, 0, 0, 0.274) 00.5px;
}
.main .body .part2 {
  background: v-bind("css.light");
  padding: 1%;
  width: 100%;
}
.options {
  height: 150px;
  margin: 1%;
  background-color: v-bind("css.light");
  color: v-bind("css.dark");
  padding: 2%;
  overflow-y: auto;
  border: 1px solid black;
}
.options ul li {
  margin: 0.5%;
}
.options ul li:hover {
  color: white;
  background-color: black;
}
.buttom {
  text-align: center;
}

@media screen and (max-width: 576px) {
  .main .body {
    background: v-bind("css.light");
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 1%;
    //   display: flex;
  }
  .main .body .part1 {
    background: v-bind("css.light");
    //   box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 1%;
    display: inline-block;
    width: 100%;
  }
  .main .body .part11 {
    width: 100%;
  }
  .main .body .part12 {
    width: 100%;
    //   border: solid rgba(0, 0, 0, 0.274) 00.5px;
  }
  .main .body .part2 {
    background: v-bind("css.light");
    padding: 1%;
    width: 100%;
  }
  .table {
    font-size: xx-small;
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
